<div style="padding: 20px; min-width: 450px;">
  <div style="margin-bottom: 20px;" *ngIf="!isReleasing">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      Hold Reason <span style="color: red;">*</span>
    </label>
    <dx-select-box data-testid="hold-task-select-box"
      [dataSource]="(holdStatuses$ | async)"
      [(value)]="selectedHoldStatus"
      (onValueChanged)="onStatusChanged($event)"
      placeholder="Select a hold reason"
      [showClearButton]="true"
      style="width: 100%;">
    </dx-select-box>
  </div>

  <!-- Comment Text Area -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      Comment <span style="color: red;" *ngIf="!isReleasing">*</span>
    </label>
    <dx-text-area data-testid="hold-task-text-area"
      [(value)]="comment"
      (onValueChanged)="onCommentChanged($event)"
      valueChangeEvent="keyup"
      [placeholder]="isReleasing ? 'Enter release comment (optional)' : 'Enter holding comment'"
      height="100"
      style="width: 100%;"
      showClearButton="true">
    </dx-text-area>
  </div>

  <!-- Action Buttons -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
    <dx-button data-testid="hold-task-button"
      [text]="isReleasing ? 'Release Task' : 'Hold Task'"
      type="default"
      [disabled]="!isFormValid()"
      (onClick)="onSubmit()">
    </dx-button>
    <dx-button data-testid="hold-task-button-1"
      text="Cancel"
      type="normal"
      (onClick)="onDismiss()">
    </dx-button>
  </div>
</div>

